/*
 * Copyright (C) 2019 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import {
  Disable2FARequest,
  PersonalDataRequest,
  Submit2FARequest,
  UserNotificationsSettingsRequest,
  UserPrivacySettingsRequest,
  Validate2FARequest,
} from '../../../shared/models/account/account.model';

export class GetPersonalData {
  static readonly type = '[Account] Get personal data';
}

export class UpdatePersonalData {
  static readonly type = '[Account] Update personal data';

  constructor(
    public request: PersonalDataRequest,
    public showMessage: boolean,
  ) {}
}

export class UpdatePersonalPrivacySettings {
  static readonly type = '[Account] Update personal privacy settings';

  constructor(public request: UserPrivacySettingsRequest) {}
}

export class UpdatePersonalNotificationsSettings {
  static readonly type = '[Account] Update personal notification settings';

  constructor(public request: UserNotificationsSettingsRequest) {}
}

export class UpdatePersonalImage {
  static readonly type = '[Account] Update personal data image';

  constructor(public imageFile: File) {}
}

export class RemoveAccountWorkspace {
  static readonly type = '[Account] Remove account workspace';

  constructor(public organizationId: string) {}
}

export class GetTwoFactorStatus {
  static readonly type = '[Account] Get 2FA status';
}

export class Generate2FASecret {
  static readonly type = '[Account] Generate 2FA secret';
}

export class Submit2FA {
  static readonly type = '[Account] Submit 2FA';

  constructor(public request: Submit2FARequest) {}
}

export class Validate2FACode {
  static readonly type = '[Account] Validate 2FA code';

  constructor(public request: Validate2FARequest) {}
}

export class Disable2FA {
  static readonly type = '[Account] Disable 2FA';

  // Optional so v2's existing `new Disable2FA()` call site keeps compiling unchanged.
  constructor(public proof?: Disable2FARequest) {}
}

export class ResetTwoFactorSetupState {
  static readonly type = '[Account] Reset 2FA setup state';
}
